module.exports = __webpack_public_path__ + "img/water_calculator.ad95ccaf.svg";